export default "__VITE_ASSET__uhLuuF_p__"